import { useModal } from 'react-native-modalfy';

import { ModalStackParamsType } from '../modals/types';
import { modals } from '../modals/modals';
import ImagePickerService, {
  ImagePickerResultType,
  IImagePickerOpenOptions,
} from '../services/ImagePickerService';
import { IS_WEB } from '@utils';

interface IOpenParams {
  pickerOpts?: IImagePickerOpenOptions;
  cameraOpts?: IImagePickerOpenOptions;
  isRemoveImageAllowed?: boolean;
  onRemoveImage?: () => void;
}

export function useImagePicker() {
  const { openModal } = useModal<ModalStackParamsType>();

  async function openPicker(options?: IImagePickerOpenOptions) {
    try {
      const res = await ImagePickerService.openPicker(options);

      return res;
    } catch (err) {
      throw err;
    }
  }

  async function openCamera(options?: IImagePickerOpenOptions) {
    try {
      const res = await ImagePickerService.openCamera(options);

      return res;
    } catch (err) {
      throw err;
    }
  }

  async function open({
    pickerOpts,
    cameraOpts,
    onRemoveImage,
    isRemoveImageAllowed,
  }: IOpenParams = {}): Promise<ImagePickerResultType> {
    return new Promise((res, rej) => {
      if (IS_WEB && !isRemoveImageAllowed) {
        return openPicker(pickerOpts).then(res).catch(rej);
      }

      return openModal(modals.ImagePickerModal, {
        onOpenPicker: () =>
          openPicker(pickerOpts).then(res).catch(rej),
        onOpenCamera: () =>
          openCamera(cameraOpts).then(res).catch(rej),
        onClose: () => res(null),
        onRemoveImage,
        isRemoveImageAllowed,
      });
    });
  }

  return {
    open,
  };
}
